/* eslint-disable react/no-danger */
import { useState } from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Container, Grid, Stack } from "@mui/material";
import Breadcrums from "components/Breadcrumbs";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/Footers/DefaultFooter";
import DefaultNavbar from "components/Navbars/DefaultNavbar";

import TreeView from "devextreme-react/tree-view";
import { information } from "./information";

function userGuide() {
  const [data] = useState(information);
  const [des, setDes] = useState(information[0]);

  const handleTreeViewSelectionChange = (e) => {
    const vals = e.itemData;
    if (vals) {
      setDes(e.itemData);
    }
  };
  return (
    <>
      <MKBox variant="gradient" style={{ backgroundColor: "#344767" }} shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light right />
      </MKBox>
      <MKBox minHeight="25rem" width="100%">
        <MKBox
          color="black"
          variant="gradient"
          p={1}
          position="relative"
          sx={{
            backgroundColor: "#FFF",
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
          }}
        />
        <MKBox component="section" bgColor="white" py={4}>
          <Container>
            <Grid container spacing={1} item xs={12} lg={12} mx="auto">
              <Grid item xs={4}>
                <Breadcrums
                  routes={[
                    { label: "Inicio", route: "/" },
                    { label: "Acerca de", route: "#" },
                    { label: "Nosotros", route: "#" },
                    { label: "Guía de uso", route: "#" },
                  ]}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          component="section"
          position="relative"
          variant="contained"
          sx={{
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
            backgroundColor: "#FFF",
            width: "100%",
          }}
        >
          <Container>
            <Grid container height="100px">
              <MKBox p={1} position="relative">
                <MKTypography variant="h1">Guía de Uso del Sitio</MKTypography>
              </MKBox>
            </Grid>
            <Grid>
              <Grid container>
                <Grid item xs={12} lg={3}>
                  <div className="option">
                    <TreeView
                      dataSource={data}
                      selectionMode="single"
                      selectByClick
                      onItemSelectionChanged={handleTreeViewSelectionChange}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={10} lg={8.5}>
                  <Stack>
                    <div
                      style={{
                        marginLeft: "5%",
                        maxWidth: "100%",
                        overflowY: "auto",
                        ml: { xs: -2, lg: "auto" },
                        mt: { xs: 4, lg: 0 },
                        marginTop: "2%",
                        textAlign: "justify",
                        height: "50vh",
                        fontFamily: "Roboto",
                        paddingRight: "25px",
                        color: "#7B809A",
                        fontSize: "16px",
                      }}
                      dangerouslySetInnerHTML={{ __html: des.description }}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default userGuide;
